import SignInPage from '@/pages/SignIn/SignInPage/SignInPage';

import { renderPageComponent } from '@/utils/react_page';
renderPageComponent(SignInPage);